module.exports = __webpack_public_path__ + "static/media/aw-logotype.d32ad2d9.svg";